// extracted by mini-css-extract-plugin
export default {"learnMorePicture":"LearnMorePicture_learnMorePicture__MiH5E","learnMorePictureTitle":"LearnMorePicture_learnMorePictureTitle__lJHiV"};